import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { InvoiceType } from '../../invoices/types/invoiceTypes';
import type { Job, JobInput, JobMaterialInput, JobMaterialStatus, JobStatus } from '../types/jobTypes';

const one = (p: Promise<ApiResponse<Job>>) => p.then((r) => r.data);

/** Service jobs (the API calls them "services"). */
export const jobService = {
  ...crudService<Job, JobInput>('/services'),
  setStatus: (id: string, status: JobStatus) => one(api.post(`/services/${id}/status`, { status })),
  assign: (id: string, assignedTo: string[], scheduledDate?: string) => one(api.post(`/services/${id}/assign`, { assignedTo, scheduledDate })),
  addNote: (id: string, text: string) => one(api.post(`/services/${id}/notes`, { text })),
  addPhotos: (id: string, kind: 'before' | 'after', urls: string[]) => one(api.post(`/services/${id}/photos`, { kind, urls })),
  /** Bills the job; returns the new draft invoice. */
  createInvoice: (id: string, invoiceType: InvoiceType) => api.post(`/services/${id}/create-invoice`, { invoiceType }).then((r) => r.data),

  // Materials planned for / used on the job
  addMaterial: (id: string, body: JobMaterialInput) => one(api.post(`/services/${id}/materials`, body)),
  updateMaterial: (id: string, materialId: string, body: Partial<JobMaterialInput>) => one(api.patch(`/services/${id}/materials/${materialId}`, body)),
  removeMaterial: (id: string, materialId: string) => one(api.del(`/services/${id}/materials/${materialId}`)),
  /** Give from stock ('issue') or take back into stock ('return'). */
  moveMaterial: (id: string, materialId: string, mode: 'issue' | 'return', qty: number) => one(api.post(`/services/${id}/materials/${materialId}/${mode}`, { qty })),
  markMaterial: (id: string, materialId: string, status: JobMaterialStatus) => one(api.post(`/services/${id}/materials/${materialId}/mark`, { status })),
};
